import * as tslib_1 from "tslib";
import { getSharingLinkInfo } from './getSharingLinkInfo';
import { assertNever } from 'owa-assert';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import getSharingInfoRequest from 'owa-service/lib/factory/getSharingInfoRequest';
import getSharingInfoResponse from 'owa-service/lib/factory/getSharingInfoResponse';
import getSharingInformationOperation from 'owa-service/lib/operation/getSharingInformationOperation';
import { trace } from 'owa-trace';
import { SharingLinkType, SharingLinkProviderType, } from '../types/SharingLinkInfoResponse';
function createRequest(attachmentUrl) {
    return getSharingInfoRequest({ attachmentUrl: attachmentUrl });
}
export function getSharingInformation(attachmentUrl) {
    if (isAttachmentFeatureEnabled('doc-attachment-sharingLinkInfoOWSPrimeService')) {
        return getSharingInfoFromOWSPrime(attachmentUrl);
    }
    return getSharingInformationOperation(createRequest(attachmentUrl));
}
function getSharingInfoFromOWSPrime(attachmentUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rawResponse, response, _a, _b, anonymousEditLink, anonymousViewLink, organizationEditLink, organizationViewLink;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getSharingLinkInfo(attachmentUrl, true)];
                case 1:
                    rawResponse = _c.sent();
                    if (!isSuccessStatusCode(rawResponse.status)) return [3 /*break*/, 3];
                    _b = (_a = JSON).parse;
                    return [4 /*yield*/, rawResponse.text()];
                case 2:
                    response = _b.apply(_a, [_c.sent()]);
                    if (isOneDriveProSharingLinkInfoResponse(response)) {
                        anonymousEditLink = response.sharingLinks.filter(function (sl) { return sl.type === SharingLinkType.AnonymousEdit; })[0];
                        anonymousViewLink = response.sharingLinks.filter(function (sl) { return sl.type === SharingLinkType.AnonymousView; })[0];
                        organizationEditLink = response.sharingLinks.filter(function (sl) { return sl.type === SharingLinkType.OrganizationEdit; })[0];
                        organizationViewLink = response.sharingLinks.filter(function (sl) { return sl.type === SharingLinkType.OrganizationView; })[0];
                        return [2 /*return*/, getSharingInfoResponse({
                                AccessRequestMode: response.accessRequestMode,
                                AnonymousEditLink: anonymousEditLink ? anonymousEditLink.url : undefined,
                                AnonymousViewLink: anonymousViewLink ? anonymousViewLink.url : undefined,
                                CanCreateAnonymousEditLink: response.canCreateAnonymousEditLink,
                                CanCreateAnonymousViewLink: response.canCreateAnonymousViewLink,
                                CanCreateOrganizationEditLink: response.canCreateOrganizationEditLink,
                                CanCreateOrganizationViewLink: response.canCreateOrganizationViewLink,
                                CanShareExternally: response.canShareExternally,
                                CanShareInternally: response.canShareInternally,
                                CanonicalUrl: response.canonicalUrl,
                                ExpirationDate: response.expirationTime,
                                FileName: response.name,
                                IsAnonymousEditLinkAvailable: !!anonymousEditLink,
                                IsAnonymousViewLinkAvailable: !!anonymousViewLink,
                                IsOrganizationEditLinkAvailable: !!organizationEditLink,
                                IsOrganizationViewLinkAvailable: !!organizationViewLink,
                                MimeType: undefined,
                                OrganizationEditLink: organizationEditLink ? organizationEditLink.url : undefined,
                                OrganizationViewLink: organizationViewLink ? organizationViewLink.url : undefined,
                                ResultCode: 0 /* Success */,
                                SharingLinkKind: convertSharingLinkTypeToSharingLinkKind(response.linkType),
                            })];
                    }
                    throw new Error('Invalid response from OWS` from sharing link info');
                case 3:
                    if (rawResponse.status === 404 /* NotFound */) {
                        return [2 /*return*/, getSharingInfoResponse({
                                ResultCode: 4 /* NotFound */,
                            })];
                    }
                    else if (rawResponse.status === 400) {
                        return [2 /*return*/, getSharingInfoResponse({
                                ResultCode: 24 /* InvalidUrl */,
                            })];
                    }
                    else {
                        trace.warn("Invalid response for OWS' get share info. Status code: " + rawResponse.status);
                        return [2 /*return*/, getSharingInfoResponse({
                                ResultCode: 1 /* GenericFailure */,
                            })];
                    }
                    _c.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function isOneDriveProSharingLinkInfoResponse(response) {
    return response.providerType === SharingLinkProviderType.OneDrivePro;
}
function convertSharingLinkTypeToSharingLinkKind(type) {
    switch (type) {
        case SharingLinkType.None:
            return 0 /* Uninitialized */;
        case SharingLinkType.View:
            return 1 /* Direct */;
        case SharingLinkType.Edit:
            return 1 /* Direct */;
        case SharingLinkType.AnonymousView:
            return 4 /* AnonymousView */;
        case SharingLinkType.AnonymousEdit:
            return 5 /* AnonymousEdit */;
        case SharingLinkType.OrganizationView:
            return 2 /* OrganizationView */;
        case SharingLinkType.OrganizationEdit:
            return 3 /* OrganizationEdit */;
        default:
            return assertNever(type);
    }
}
//# sourceMappingURL=getSharingInformation.js.map